import { $ } from "@olmokit/dom";

import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import "./index.scss";

/**
 * Component: MenuAnchor
 */
export function MenuAnchor() {
  console.log("MenuAnchor mounted.");

  const el = document.querySelector("#MenuAnchor")
  if (el) {
    const observer = new IntersectionObserver( 
      ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(el);
  }

}
